import { useEffect } from 'react'
import { useDispatch } from 'react-redux'

// Actions
import { actions as cmsActions } from 'modules/cms/actions'
import { actions as staticpagesActions } from 'modules/staticpages/actions'
import { actions as trackingActions } from 'modules/tracking/actions'

// Components
import SimpleStreamFieldPage from 'components/staticpages'
import SEO from 'components/base/seo'
import Hero from 'components/kit/hero/hero'

// Hooks
import { useStaticPageByPath } from 'modules/staticpages/hooks'

// Types
import { CmsPage, InitialDataProps, Dispatch, GetState } from 'types'

const ucFirst = (string: string): string => string.charAt(0).toUpperCase() + string.slice(1)

export const getTitle = (page: CmsPage | null | undefined, pageTitle: string | null): string => {
  if (page && page.meta.seo_title) {
    return page.meta.seo_title
  }
  if (page && page.title) {
    return `${ucFirst(page.title)} | Tracklib`
  }
  if (pageTitle) {
    return `${ucFirst(pageTitle)} | Tracklib`
  }
  return 'Sample on Tracklib'
}

export const loadInitialData = ({ location: { path } }: InitialDataProps<unknown>) => {
  return (dispatch: Dispatch, getState: GetState) =>
    dispatch(staticpagesActions.loadPageByPath(path.replace('/', ''))).then(() => {
      // NOTE(kitti): This is a hardcoded hack solution to load blog index cms page completley on server
      const state = getState()
      const { pages } = state.entities
      const pageList = Object.keys(pages).map(id => pages[id])
      if (pageList && pageList.length) {
        const pagesToLoad = pageList[0].content.reduce<Array<Promise<unknown>>>((agg, content) => {
          if (content.type === 'hero_article') {
            const articleId = content.value.hero_articles && content.value.hero_articles[0].article
            return [...agg, dispatch(cmsActions.fetchArticlesByIds([articleId || 0]))]
          }
          if (content.type === 'featured_blog_grid') {
            return [...agg, dispatch(cmsActions.fetchAllArticleSummaries())]
          }
          return agg
        }, [])
        return Promise.all(pagesToLoad)
      }
      return null
    })
}

type StaticPageProps = {
  match: {
    path: string
    isExact: boolean
  }
}

const StaticPage = ({ match: { path: propsPath } }: StaticPageProps) => {
  const dispatch = useDispatch()
  const path = propsPath.replace('/', '')
  const { page, request } = useStaticPageByPath(path)
  const hasFeaturedBlogGrid = page?.content.some(content => content.type === 'featured_blog_grid')
  useEffect(() => {
    dispatch(
      trackingActions.trackevent('Viewed page', {
        page: path,
      }),
    )
  }, [path]) // eslint-disable-line
  useEffect(() => {
    if (hasFeaturedBlogGrid) {
      dispatch(cmsActions.fetchAllArticleSummaries())
    }
  }, [path, hasFeaturedBlogGrid, dispatch])

  const title = getTitle(page, propsPath.replace('/', ''))
  return (
    <div>
      <SEO title={title} />
      {request.isLoading && <Hero loadingState />}
      {page && <SimpleStreamFieldPage page={page} />}
    </div>
  )
}

export default StaticPage
